import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../lib/auth.context'
import { Button } from '../ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu'
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'

export function UserMenu() {
  const { isAuthenticated, user, logout } = useAuth()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = React.useState(false)

  const handleLogout = async () => {
    setIsLoading(true)
    try {
      await logout()
      // Force navigation to login page even if there was an error
      navigate('/login', { replace: true })
    } catch (error) {
      console.error('Error logging out:', error)
      // Still navigate to login page on error
      navigate('/login', { replace: true })
    } finally {
      setIsLoading(false)
    }
  }

  if (!isAuthenticated) {
    return (
      <div className="flex gap-2">
        <Button variant="ghost" onClick={() => navigate('/login')} disabled={isLoading}>
          Login
        </Button>
      </div>
    )
  }

  if (!user) {
    return null
  }

  const userInitial = user.email?.[0]?.toUpperCase() || '?'

  // Helper function to handle navigation with hash routing
  const navigateTo = (path: string) => {
    console.log(`UserMenu: Navigating to ${path}`);
    // Use navigate function from react-router-dom with replace option to ensure proper routing
    navigate(path, { replace: true });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            {user.user_metadata?.avatar_url ? (
              <AvatarImage src={user.user_metadata.avatar_url} alt={user.email || ''} />
            ) : (
              <AvatarFallback>{userInitial}</AvatarFallback>
            )}
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => navigateTo('/admin/profile')}>
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href="#/admin/account-settings">Account Settings</a>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout} disabled={isLoading}>
          {isLoading ? 'Logging out...' : 'Logout'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
